import { ReactNode } from "react";

import { FormattedMessage } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { Adg4TextUnderline } from "@/components/adg4/text-underline/src/text-underline";
import { Picture } from "@/components/wpl/image/src/image";
import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { ADG4CtaWithPolygonBackground } from "@/patterns/adg4/cta-with-polygon-background/cta-with-polygon-background";

export const GetStartedCTA = () => {
    return (
        <UFOSegment name="homepage-v2-getStartedCta">
            <ADG4CtaWithPolygonBackground
                backgroundColor="#1868DB"
                header={
                    <FormattedMessage
                        id="HomePageTemplateV2.getStartedCtaHeader"
                        defaultMessage="Unleash the power of <teamwork>teamwork</teamwork>"
                        values={{
                            teamwork: (str: ReactNode) => (
                                <Adg4TextUnderline
                                    underline={
                                        <Picture
                                            image={{
                                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/816103v2hjv7e5ir82gt8c421jo5knw3.svg",
                                                alt: "",
                                                width: 277,
                                                height: 7
                                            }}
                                        />
                                    }
                                >
                                    {str}
                                </Adg4TextUnderline>
                            )
                        }}
                    />
                }
                paragraph={
                    <FormattedMessage
                        id="HomePageTemplateV2.getStartedCtaParagraph"
                        defaultMessage="Join millions teaming up on their best work"
                    />
                }
                ctaText={
                    <FormattedMessage
                        id="HomePageTemplateV2.getStartedCtaButton"
                        defaultMessage="Get started for free"
                    />
                }
                ctaUrl={useLocalizedHref(
                    "/try/cloud/signup?bundle=jira-software"
                )}
                ctaLabel={"Get started for free"}
                productKey="home"
            />
        </UFOSegment>
    );
};

GetStartedCTA.displayName = "GetStartedCTA";
